export enum CurrentTapType {
  all = "orders_all",
  pending = "orders_pending",
  inProgress = "orders_inProgress",
  delivered = "orders_delivered",
  cancelled = "orders_cancelled",
  rejected = "common_rejected",
}

export enum PaymentStatus {
  unpaid = "orders_unpaid",
  pendingPayment = "orders_pendingPayment",
  paid = "orders_paid",
}
